import React, { useRef } from "react";

import { isArray, map } from "lodash";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import basic from "@/assets/images/webp/basic.webp";
import elite from "@/assets/images/webp/elite.webp";
import plus from "@/assets/images/webp/plus.webp";
import pro from "@/assets/images/webp/Pro-Partner.webp";
import { Link } from "react-router-dom";

import { motion } from "framer-motion";


const PartnerBanners = ({ promotionPartner }) => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const sectionRef = useRef(null);

  const partnerBannersRef = useRef(null);

  const options = {
    loop: true,
    margin: 20,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    navText: ["<< ", ">>"],
    video: false,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 },
      1280: { items: 1 },
      1440: { items: 1 },
    },
  };

  const goToNext = () => {
    partnerBannersRef.current.next();
  };

  const goToPrev = () => {
    partnerBannersRef.current.prev();
  };

  return (
    <>
      <div ref={sectionRef}>
        <motion.h2 className={`head animate-child`}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          custom={0.1}
          variants={fadeUpVariant}
        >Newly Joined Partners</motion.h2>
        <section
          className="newly-joined-swiper"
        >
          {/* Text Swiper (Horizontal + Fade) START */}
          <div className="slider-container">
            {isArray(promotionPartner) && promotionPartner.length > 1 && (
              <>
                <OwlCarousel className="owl-theme" {...options} ref={partnerBannersRef}>
                  {map(promotionPartner, (val, i) => (

                    <div key={`partner_banner${i}`}>
                      <div>
                        <img
                          src={val.image}
                          alt={`Slide ${i}`}
                          className="object-cover"
                          width={1080}
                          height={429}
                        />
                      </div>

                      <div className="text-slider-wrape">
                        <div className="bedge-wrape">
                          {val.badge === 'Basic' ? (
                            <img src={basic} alt="Basic" loading="lazy" />
                          ) : val.badge === 'Pro' ? (
                            <img src={pro} alt="Pro" loading="lazy" />
                          ) : val.badge === 'Plus' ? (
                            <img src={plus} alt="Plus" loading="lazy" />
                          ) : val.badge === 'Elite' ? (
                            <img src={elite} alt="Elite" loading="lazy" />
                          ) : (
                            <img src={basic} alt="badge" loading="lazy" />
                          )}
                        </div>

                        <div className="content-wrape">
                          <motion.h3 className={`animate-child`}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.1 }}
                            custom={0.1}
                            variants={fadeUpVariant}
                          >
                            {val.companyName || val.company_name}
                          </motion.h3>
                          <div className="contact-detail">
                            <div className="left">
                              {val?.url && (() => {
                                const isExternal = !val.url.startsWith("/");
                                const normalizedUrl = isExternal
                                  ? val.url.startsWith("http")
                                    ? val.url
                                    : `https://${val.url}`
                                  : val.url;

                                return isExternal ? (
                                  <motion.div
                                    className="animate-child"
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true, amount: 0.1 }}
                                    custom={0.1}
                                    variants={fadeUpVariant}
                                  >
                                    <Link
                                      to={normalizedUrl}
                                      href={normalizedUrl}
                                      title={val.url}
                                      target="_blank"
                                      rel="noopener noreferrer"

                                    >
                                      <i className="icon web"></i> {val.url}
                                    </Link>
                                  </motion.div>

                                ) : (
                                  <motion.div
                                    className="animate-child"
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true, amount: 0.1 }}
                                    custom={0.1}
                                    variants={fadeUpVariant}
                                  >
                                    <Link
                                      to={normalizedUrl}
                                      href={normalizedUrl}
                                      title={val.url}

                                    >
                                      <i className="icon web"></i> {val.url}
                                    </Link>
                                  </motion.div>

                                );
                              })()}

                              {val.email && (

                                <motion.p className={`animate-child`}
                                  initial="hidden"
                                  whileInView="visible"
                                  viewport={{ once: true, amount: 0.1 }}
                                  custom={0.1}
                                  variants={fadeUpVariant}
                                >
                                  <a href={`mailto:${val.email}`} title={val.email}>
                                    <i className="icon mail"></i> {val.email}
                                  </a>
                                </motion.p>
                              )}
                            </div>

                            <motion.div className={`right animate-child`}
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.1 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >
                              {val.member_unique_number && (
                                <p><b>Orex ID:</b> {val.member_unique_number}</p>
                              )}
                            </motion.div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </OwlCarousel>

                {
                  isArray(promotionPartner) && promotionPartner.length > 1 && <div className="slide-nav-wrape">
                    <button type="button" className="btn prev" onClick={goToPrev}>
                      <i className="sprite"></i>
                    </button>
                    <button type="button" className="btn next" onClick={goToNext}>
                      <i className="sprite"></i>
                    </button>
                  </div>
                }
              </>
            )}

            { /** Single Image */}
            {
              isArray(promotionPartner) && promotionPartner.length <= 1 && (
                <>
                  {
                    map(promotionPartner, (val, i) => (
                      <div key={`partner_banner${i}`}>
                        <div>
                          <img
                            src={val.image}
                            alt={`Slide ${i}`}
                            className="object-cover"
                          />
                        </div>


                        <div className="text-slider-wrape">
                          <div className="bedge-wrape">
                            {val.badge === 'Basic' ? (
                              <img src={basic} alt="Basic" loading="lazy" />
                            ) : val.badge === 'Pro' ? (
                              <img src={pro} alt="Pro" loading="lazy" />
                            ) : val.badge === 'Plus' ? (
                              <img src={plus} alt="Plus" loading="lazy" />
                            ) : val.badge === 'Elite' ? (
                              <img src={elite} alt="Elite" loading="lazy" />
                            ) : (
                              <img src={basic} alt="badge" loading="lazy" />
                            )}

                          </div>
                          <div className="content-wrape">

                            <motion.h3 className={`animate-child`}
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.1 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >
                              {val.companyName || val.company_name}
                            </motion.h3>
                            <div className="contact-detail">
                              <div className="left">
                                {val?.url && (() => {
                                  const isExternal = !val.url.startsWith("/");
                                  const normalizedUrl = isExternal
                                    ? val.url.startsWith("http")
                                      ? val.url
                                      : `https://${val.url}`
                                    : val.url;

                                  return isExternal ? (
                                    <motion.div
                                      className="animate-child"
                                      initial="hidden"
                                      whileInView="visible"
                                      viewport={{ once: true, amount: 0.1 }}
                                      custom={0.1}
                                      variants={fadeUpVariant}
                                    >
                                      <Link
                                        to={normalizedUrl}
                                        href={normalizedUrl}
                                        title={val.url}
                                        target="_blank"
                                        rel="noopener noreferrer"

                                      >
                                        <i className="icon web"></i> {val.url}
                                      </Link>
                                    </motion.div>

                                  ) : (
                                    <motion.div
                                      className="animate-child"
                                      initial="hidden"
                                      whileInView="visible"
                                      viewport={{ once: true, amount: 0.1 }}
                                      custom={0.1}
                                      variants={fadeUpVariant}
                                    >
                                      <Link
                                        to={normalizedUrl}
                                        href={normalizedUrl}
                                        title={val.url}

                                      >
                                        <i className="icon web"></i> {val.url}
                                      </Link>
                                    </motion.div>

                                  );
                                })()}

                                {val.email && (

                                  <motion.p className={`animate-child`}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true, amount: 0.1 }}
                                    custom={0.1}
                                    variants={fadeUpVariant}
                                  >
                                    <a href={`mailto:${val.email}`} title={val.email}>
                                      <i className="icon mail"></i> {val.email}
                                    </a>
                                  </motion.p>
                                )}
                              </div>

                              <motion.div className={`right animate-child`}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.1 }}
                                custom={0.1}
                                variants={fadeUpVariant}
                              >
                                {val.member_unique_number && (
                                  <p><b>Orex ID:</b> {val.member_unique_number}</p>
                                )}
                              </motion.div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  }
                </>
              )
            }
          </div>
        </section>
      </div>
    </>

  );
}

export default PartnerBanners;
